module.exports = __webpack_public_path__ + "img/icon2.e6b65460.png";